// ContactPage.jsx
// Form, kullanıcının e-posta uygulamasını mesaj hazır şekilde açar (mailto). Sunucuya
// gönderim olmadığı için "mesajınız alındı" gibi yanıltıcı bir bildirim gösterilmez.

import React, { useState } from 'react';
import Seo from '../components/Seo';
import PageHeader from '../components/PageHeader';
import { useLang } from '../i18n';
import { CONTACT_EMAIL, SOCIAL } from '../config/links';

const C = {
  tr: {
    title: 'İletişim',
    seoDesc: 'Şogi Türkiye ile iletişime geçin: görüş, öneri, iş birliği ve turnuva organizasyonları için e-posta ve sosyal medya.',
    lead: 'Görüş, öneri, iş birliği veya turnuva organizasyonu için bize yazın.',
    reach: 'Bize ulaşın',
    reachText: 'E-posta ile doğrudan yazabilir ya da sosyal medyadan takip edebilirsiniz.',
    email: 'E-posta',
    social: 'Sosyal medya',
    form: 'Mesaj gönder',
    name: 'Adınız',
    subject: 'Konu',
    message: 'Mesajınız',
    send: 'E-posta uygulamasında aç',
    note: 'Gönder düğmesi, mesajınız hazır şekilde e-posta uygulamanızı açar.',
    opened: 'E-posta uygulamanız açılıyor. Açılmazsa {email} adresine yazabilirsiniz.',
  },
  en: {
    title: 'Contact',
    seoDesc: 'Contact Shogi Türkiye: email and social media for feedback, suggestions, partnerships and tournaments.',
    lead: 'Write to us with feedback, ideas, partnership requests or tournament plans.',
    reach: 'Get in touch',
    reachText: 'Email us directly or follow us on social media.',
    email: 'Email',
    social: 'Social media',
    form: 'Send a message',
    name: 'Your name',
    subject: 'Subject',
    message: 'Your message',
    send: 'Open in my email app',
    note: 'The button opens your email app with the message ready to send.',
    opened: 'Opening your email app. If nothing happens, write to {email}.',
  },
};

export default function ContactPage() {
  const { lang } = useLang();
  const c = C[lang];
  const [form, setForm] = useState({ name: '', subject: '', message: '' });
  const [opened, setOpened] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const body = `${form.message}\n\n— ${form.name}`;
    window.location.href = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(form.subject)}&body=${encodeURIComponent(body)}`;
    setOpened(true);
  };

  const field = (key) => ({
    value: form[key],
    onChange: (e) => setForm({ ...form, [key]: e.target.value }),
  });

  return (
    <>
      <Seo title={c.title} description={c.seoDesc} />
      <PageHeader title={c.title} lead={c.lead} crumbs={[{ label: c.title }]} />
      <div className="container">
        <div className="row g-3 g-md-4">
          <div className="col-12 col-lg-5">
            <section className="panel h-100">
              <h2>{c.reach}</h2>
              <p className="text-muted">{c.reachText}</p>
              <div className="mb-3">
                <div className="fw-bold">{c.email}</div>
                <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
              </div>
              <div className="fw-bold mb-2">{c.social}</div>
              <div className="d-flex gap-2 flex-wrap">
                <a href={SOCIAL.youtube} target="_blank" rel="noopener noreferrer" className="btn btn-soft btn-sm">YouTube</a>
                <a href={SOCIAL.instagram} target="_blank" rel="noopener noreferrer" className="btn btn-soft btn-sm">Instagram</a>
              </div>
            </section>
          </div>
          <div className="col-12 col-lg-7">
            <section className="panel">
              <h2>{c.form}</h2>
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label fw-semibold" htmlFor="cf-name">{c.name}</label>
                  <input id="cf-name" type="text" className="form-control" required {...field('name')} />
                </div>
                <div className="mb-3">
                  <label className="form-label fw-semibold" htmlFor="cf-subject">{c.subject}</label>
                  <input id="cf-subject" type="text" className="form-control" required {...field('subject')} />
                </div>
                <div className="mb-3">
                  <label className="form-label fw-semibold" htmlFor="cf-message">{c.message}</label>
                  <textarea id="cf-message" className="form-control" rows="5" required {...field('message')} />
                </div>
                <button type="submit" className="btn btn-ink">{c.send}</button>
                <p className="small text-muted mt-2 mb-0">{c.note}</p>
                {opened && (
                  <div className="alert alert-info small mt-3 mb-0">{c.opened.replace('{email}', CONTACT_EMAIL)}</div>
                )}
              </form>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}
